import { render, staticRenderFns } from "./CustomizeMetalAW.vue?vue&type=template&id=77eb9370&scoped=true"
import script from "./CustomizeMetalAW.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAW.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAW.vue?vue&type=style&index=0&id=77eb9370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eb9370",
  null
  
)

export default component.exports